import React from 'react'

const INS = () => {
  return (
    <div>
        
        <div className=' text-center my-5 mx-5'>
    <h2 class="card-title py-2" >Our Musical <span style={{color:"#FFD700"}}>Instruments</span> </h2>
    <h5 class="card-text my-3" >With supporting text below as a natural lead-in to additional content.</h5>
    </div>

    <div className=' row '>


    <div class=" col mx-5 px-5 my-2">
  <img src="https://easydrawingguides.com/wp-content/uploads/2021/08/drum-step-by-step-drawing-tutorial-step-10.png" class="card-img-top py-5"  alt="..."/>
  <div class="card-body">
    <h5 class="card-title" ><b>Drum</b></h5>
    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
    
  </div>
</div>

<div class=" col mx-5 px-5 my-2">
  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiQ8OAT0tNaqmpmGW3R4SUu3eRI-36_n4HWw&usqp=CAU" class="card-img-top py-5" alt="..."/>
  <div class="card-body">
    <h5 class="card-title"><b>Guitar</b></h5>
    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
   
  </div>
</div>

<div class=" col mx-5 px-5 my-2">
  <img src="https://cdn2.vectorstock.com/i/thumb-large/18/56/electronic-keyboard-musical-instrument-vector-32311856.jpg" class="card-img-top py-5" alt="..."/>
  <div class="card-body">
    <h5 class="card-title"><b>Keyboard</b></h5>
    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
   
  </div>
</div>

<div class=" col mx-5 px-5 my-2">
  <img src="https://cdn-icons-png.flaticon.com/512/4787/4787091.png" class="card-img-top py-5" alt="..."/>
  <div class="card-body">
    <h5 class="card-title"><b>Tabla</b></h5>
    <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
   
  </div>
</div>

</div>

    </div>
  )
}

export default INS